/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import {DataReference} from "../shared/DataReference";
import {PurchasedEvent} from "../models/PurchasedEvent";
import {CompEvent} from "../models/CompEvent";
import {BehaviorSubject} from "rxjs";
import {Venue} from "../models/Venue";
import {ReplaySubject} from "rxjs/ReplaySubject";
import {EventAdjudicator} from "../models/schedule/Adjudicator";
import {Observable} from "rxjs/Observable";
import {Subject} from "rxjs/Subject";
import {AuthService} from "./auth-service";
import * as firebase from "firebase";
import {InAppPurchase} from "@ionic-native/in-app-purchase";
import {Device} from "@ionic-native/device";
import {Platform} from "ionic-angular";
import {FirebaseApp} from "angularfire2";
import {AngularFireDatabase} from "angularfire2/database";
import {EventFeatures} from "../models/EventFeatures";


@Injectable()
export class EventService {

  private _purchaseEvents$: BehaviorSubject<Array<PurchasedEvent>>;
  private _events: CompEvent[] = [];

  get purchasedEvents() {
    return this._purchaseEvents$.asObservable();
  }

  constructor(private firebase: FirebaseApp,
              private af: AngularFireDatabase,
              private iap: InAppPurchase,
              private device: Device,
              private platform: Platform,
              private authService: AuthService) {
    // console.log('Hello EventService Provider');

    this._purchaseEvents$ = new BehaviorSubject([]);
  }

  loadPurchasedEventsForUser(userId: string) {
    console.log('load purchased events for user ' + userId);
    this._purchaseEvents$.next([]);

    // this.af.list(DataReference.getEventsPurchasedRef(userId), ref => ref.orderByChild(DataReference.ENTRY_STATUS).startAt(EntryStatus.Confirmed))
    //   .snapshotChanges(['child_added', 'child_removed', 'child_changed'])
    //   .subscribe(snapshots => {
    //     let purchased = PurchasedEvent.fromAngularFireSnapshots(snapshots);
	//
    //     console.log(purchased);
	//
    //     this.getEventById(purchased.event.id).then(event => {
    //       if (event) {
    //         purchased.event = event;
    //         let events = this._purchaseEvents$.getValue();
    //         events.push(purchased);
    //         this._purchaseEvents$.next(events);
    //       }
    //     });
    //   });

    this.firebase.database().ref(DataReference.getEventsPurchasedRef(userId)).on(DataReference.Add, snapshot => {
      if (snapshot.exists()) {
        let purchased = PurchasedEvent.fromSnapshot(snapshot);
        console.log(purchased);

        this.getEventById(purchased.event.id).then(event => {
          if (event) {
            purchased.event = event;
            let events = this._purchaseEvents$.getValue();
            events.push(purchased);
            this._purchaseEvents$.next(events);
          }
        });
      }
    }, err => {
      console.error(err);
    });
  }

  getEventById(eventId: string) : Promise<CompEvent> {
    return new Promise((resolve, reject) => {
      this.firebase.database().ref(DataReference.getEventsRef(eventId)).once(DataReference.Value, snapshot => {
        if (snapshot.exists()) {
          resolve(CompEvent.fromSnapshot(snapshot));
        } else {
          resolve(null);
        }
      }, err => {
        console.error(err);
        reject(err);
      });
    });
  }

  watchEventById(eventId: string) : Observable<CompEvent> {
    return this.af.object(DataReference.getEventsRef(eventId))
      .valueChanges()
      .map(e => CompEvent.fromJson(eventId, e));
  }

  getVenueById(venueId: string) : Promise<Venue> {
    return new Promise((resolve, reject) => {
      this.firebase.database().ref(DataReference.getVenuesRef(venueId)).once(DataReference.Value, snapshot => {
        if (snapshot.exists()) {
          resolve(Venue.fromSnapshot(snapshot));
        } else {
          resolve(null);
        }
      }, err => {
        console.error(err);
        reject(err);
      });
    });
  }

  getAdjudicators(eventId: string) : Observable<EventAdjudicator[]> {
    console.log(`Load adjudicators for ${eventId}`);

    let subject: Subject<EventAdjudicator[]> = new ReplaySubject();

    this.firebase.database().ref(DataReference.getAdjudicators(eventId)).once(DataReference.Value, snapshot => {
      if (snapshot.exists() && snapshot.hasChildren()) {
        console.log('We have stuff');
        let stuff = EventAdjudicator.fromSnapshots(snapshot);
        subject.next(stuff);
        subject.complete()
      } else {
        console.log('No adjudicators found');
        subject.next([]);
        subject.complete();
      }
    }, err => {
      console.error(err);
      subject.error('Error getting adjudicators');
      subject.complete();
    });

    return subject.asObservable();
  }

  // TODO: move this to purchasing service
  purchaseEvent(eventKey: string) : Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {

      const userId: string = this.authService.getCurrentUserId();

      if (!eventKey || !userId) {
        console.warn('event key or user id missing');
        reject('Error purchasing event');
      } else {

        // check if we already have this event
        const eventPurchasedRef = `${DataReference.getEventsPurchasedRef(userId)}/${eventKey}`;
        this.firebase.database().ref(eventPurchasedRef).once(DataReference.Value, snap => {

          if (snap.exists()) {
            reject('Event already purchased');
          } else {
            console.log('event has not been redeemed before');
            // make sure the event exists
            this.getEventById(eventKey).then(event => {

              if (event) {
                const date = Date.now();
                const data = {
                  dateAdded: date,
                  datePurchased: date
                };

                console.log('going to make purchase');
                console.log(data);
                // resolve(true);

                this.firebase.database().ref(eventPurchasedRef).update(data, err => {
                  if (err) {
                    console.error(err);
                    reject('Error redeeming code');
                  } else {
                    resolve(true);
                  }
                });

              } else {
                console.log('event is not valid');
                reject('Event for code not found')
              }
            });
          }

        });
      }


    });

  }

  getEventsForTour(compId: string, tourId: string) {

    let events: Array<CompEvent> = [];
    let events$: Subject<Array<CompEvent>> = new Subject();

    firebase.database().ref(DataReference.getTourEventsKeysRef(compId, tourId)).once(DataReference.Value, snapshot => {
      console.log(snapshot.key);
      // console.log(snapshot.val());
      if (snapshot.exists() && snapshot.hasChildren()) {
        let eventIds: Array<string> = [];

        snapshot.forEach(child => {
          if (child.val()) {
            eventIds.push(child.key);
          }
          return null;
        });

        for (let eventId of eventIds) {
          this.getEventById(eventId).then(event => {
            events.push(event);
            events$.next(events);
          });
        }
      } else {
        events$.next([]);
        console.log('No events found');
      }
    }, err => {
      console.error(err);
    });

    return events$.asObservable();
  }



  getEventForCode(code: string) : Promise<string> {
    return new Promise((resolve, reject) => {
      this.firebase.database().ref(DataReference.getEventForCode(code)).once(DataReference.Value, snapshot => {
        console.log('getEventForCode callback for ' + code);
        if (snapshot.exists()) {
          console.log('snapshotExists');
          const eventKey: string = snapshot.val().eventKey;
          const isActive: boolean = snapshot.val().isActive;
          console.log(eventKey);
          console.log(isActive);

          if (isActive) {
            console.log('code is active');
            resolve(eventKey);
          } else {
            console.log('code not active');
            reject(null);
          }
        } else {
          console.log('snapshot does not exist');
          resolve(null);
        }
      }, err => {
        console.error(err);
        reject('Error fetching event for code');
      });
    });
  }

  static getProductIdsForEvent(eventId: string) : string[] {
    const baseId = 'stagesprite.';
    return [`${baseId}${eventId.toLowerCase()}`];
  }

  hasUserPurchasedEvent(eventId: string) : Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      const productIds = EventService.getProductIdsForEvent(eventId);

      this.iap.restorePurchases()
        .then(products => {
          let productExists = false;
          for (let i = 0; i < products.length; i++) {
            if (products[i].productId == productIds[0]) {
              productExists = true;
              break;
            }
          }

          resolve(productExists);
        }).catch(err => {
          console.error(err);
          reject('Unable to fetch purchases');
      });
    });
  }

  watchForOverrideChange(userId: string, deviceId: string) : Observable<CompEvent> {
    let subject = new Subject<CompEvent>();

    this.firebase.database().ref(DataReference.getEventAuthorizationRef(userId, deviceId))
      .on(DataReference.Add, snapshot => {
      if (snapshot.exists()) {
        let eventId = snapshot.key;

        this.getEventById(eventId).then(event => {
          if (event) {
            subject.next(event);
          }
        });

      } else {
        console.log('nothing is here');
      }
    }, err => {
        console.error(err);
      });

    return subject;
  }

  clearOverrideWatch(userId: string, deviceId: string, eventId: string) {

    let data = {};
    data[eventId] = null;

    this.firebase.database().ref(DataReference.getEventAuthorizationRef(userId, deviceId))
      .update(data, () => {
        console.log('cleared');
      });
  }

  userCanAccessEvent(purchasedEvent: PurchasedEvent) : Promise<boolean> {

    return new Promise<boolean>((resolve, reject) => {

      if (!purchasedEvent) {
        console.error('Purchased event is empty');
        reject('Unknown event');
        return;
      }

      // users should be able to access all free events
      if (purchasedEvent.event.eventAccess.isFree) {
        resolve(true);
        return;
      }

      // users should be able to access the event if it is complete
      if (purchasedEvent.event.isComplete()) {
        resolve(true);
        return;
      }

      // if not running on a mobile device, assume user is authorized
      if (!this.platform.is('cordova')) {
        resolve(true);
        return;
      }

      // check if the device has an override
      let uuid = this.device.uuid;
      if (purchasedEvent.deviceOverride && purchasedEvent.deviceOverride.length > 0 && uuid &&
        purchasedEvent.deviceOverride.indexOf(uuid) > -1) {

        resolve(true);
        return;
      }

      // otherwise ensure that user has purchased the event
      this.hasUserPurchasedEvent(purchasedEvent.event.id).then(res => {
        resolve(res);
      }, err => {
        console.error(err);
        reject(err);
      });
    });
  }

  watchFeaturesForEvent(eventId: string) {
    return this.af.object(DataReference.getFeaturesForEvent(eventId))
      .valueChanges()
      .map(EventFeatures.fromJson);
  }

}



// WEBPACK FOOTER //
// ./src/providers/event-service.ts